import { render } from "./ColaboradoresTable.vue?vue&type=template&id=24898e4f"
import script from "./ColaboradoresTable.vue?vue&type=script&lang=js"
export * from "./ColaboradoresTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__